import { fixFeatureButton, customizeSearch, updateContentMargin } from '../js/utils/helpers';
import { createCustomToggle } from '../js/utils/handleNavigation';

$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  fixFeatureButton();
  customizeSearch();
  modifySignup();
  updateContentMargin();
  createCustomToggle();
});

// Customize Sign Up Widget
function modifySignup() {
  const signupWidget = $('.homepage .emailSignup');

  signupWidget.each(function () {
    const $this = $(this);
    const inputField = $this.find('.emailInputField');
    const submitButton = $this.find('.emailInputSubmit');

    $this.find('.emailSignupText').replaceWith(`
      <div class="emailSignupTextContainer">    
        <h2><span>join our</span>Community</h2>
      </div>`);

    $(inputField.add(submitButton)).wrapAll('<div class="signup-form"></div>');

    inputField
      .find('.inputFieldTextbox')
      .val('')
      .attr('placeholder', 'Email Address')
      .attr('aria-label', 'Enter Email Address');

    submitButton.find('.emailSubmitButton').text('Subscribe');
  });
}
